/** 判断账号是否拥有一个或任意一个业务权限。 */
export function hasPermission (user = {}, required) {
  if (user.is_god === true) return true
  const permissions = Array.isArray(user.permissions) ? user.permissions : []
  const requiredList = Array.isArray(required) ? required : [required]
  return requiredList.some(code => code && permissions.includes(code))
}

/** 使用统一规则判断账号能否访问路由。 */
export function canAccessRouteMeta (user = {}, meta = {}, params = {}) {
  if (meta.selfOrOwner === true) {
    return user.is_god === true ||
      user.is_owner === true ||
      String(params.id || '') === String(user.id || '')
  }
  if (meta.authenticatedOnly === true) return true
  if (user.is_god === true) return true
  if (meta.godOnly === true) return false
  if (meta.ownerOnly === true) return user.is_owner === true

  const permissions = Array.isArray(user.permissions) ? user.permissions : []
  if (meta.businessOnly === true) return permissions.length > 0
  if (meta.permission) return hasPermission(user, meta.permission)
  if (Array.isArray(meta.permissions)) return hasPermission(user, meta.permissions)
  return false
}
